module.exports = __webpack_public_path__ + "img/gallery-1.e806af5f.jpg";